import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-vertreter-list-view',
  imports: [],
  templateUrl: './vertreter.list-view.html',
  styleUrls: ['./vertreter.list-view.css'],
})
export class VertreterListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
